















import Vue, { PropType } from "vue";

export default Vue.extend({
  name: "LazyImage",
  props: {
    imageSrc: String as PropType<string>,
    imageAlt: String as PropType<string>,
    imageStyle: String as PropType<string>,
    imageClass: String as PropType<string>,
    imageId: String as PropType<string>
  },
  data() {
    return {
      show: true,
      rounded: false
    };
  }
});
